import * as React from 'react';
import { PageProps } from "src/models/common/ComponentProps";
import bindAllOfThis from "src/utils/BindThisHelper";
import { message } from 'antd';
import PhaserFindHelpersGame from 'src/games/FindHelpersGame/Main';

interface FindHelpersGameProps extends PageProps<{}> {
    onComplete?: () => void;
}

class FindHelpersGame extends React.Component<FindHelpersGameProps> {
    constructor(props: FindHelpersGameProps) {
        super(props);
        bindAllOfThis(this, FindHelpersGame.prototype);
    }

    completeGame() {
        return message.success("You finished the game!");
    }

    render() {
        return <div>
            <PhaserFindHelpersGame onComplete={this.completeGame}/>
        </div>;
    }
}

export default FindHelpersGame;



// WEBPACK FOOTER //
// ./src/pages/game/FindHelpersGame.tsx